<template>
  <div style="overflow: hidden;">
    <v-layout>
      <v-flex md12 sm12>
        <v-icon v-if="$root.activeMobileMenu" style="color: #fff;" @click="closeMobileMenu()" class="btnIcon mr-2 ml-2">arrow_back</v-icon>
        <img :class="[$root.isRTL ? 'logoSmallRTL' : 'logoSmall']" src="../assets/yomanet.png" @click="menuClick('Home')" />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md1>
        <i class="material-icons icon w3-text-white" style="font-size: 24px;">person</i>
      </v-flex>
      <v-flex md11 style="text-align:right; font-size: 16px; padding: 5px 20px;">
        {{$root.user.FullName}}
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

  export default {
    name: 'Logo',
    data() {
      return {
        name: '',
      }
    },
    created() {
      this.$Log("Vue [Logo] is created ...");
    },
    ready() {
      this.$Log("Vue [Logo] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Logo] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Logo] is updated ...");
      //this.getName();
      //this.name = this.$root.user.FullName;
    },
    methods: {
      closeMobileMenu() {
        this.$root.activeMobileMenu = false;
      },
      //getName() {
      //  //$root.user.FullName
      //  if (this.$root.user.Type == 'רוכש') {
      //    //return this.$root.customer.FullName;
      //    return this.name = this.$root.user.FullName;
      //  }
      //  else {
      //    this.name = this.$root.user.FullName;
      //  }
      //},
      menuClick(item) {
        this.$Log("Clicked item  >>> " + JSON.stringify(item));
        switch (item.page) {
          case 'Logout': this.confirmSignout(); this.break;
          default: this.$router.push({ name: item.page }); break;
        }
      },
      confirmSignout() {
        this.$root.confirm = {
          isVisible: true,
          title: 'יציאה',
          question: 'האם אתה בטוח ברצונך לצאת מהמערכת?',
          caller: 'Signout',
          isConfirmed: false
        }
      },
      signout() {
        this.$localStorage.remove('user');
        this.$root.user = null;
        this.$root.isHome = true;
        this.$router.push({ name: 'Login' });
      }
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// Logo.vue?772bf934